export var TimeZone;
(function (TimeZone) {
    function is(value) {
        let result;
        try {
            result = typeof value == "string" && !!new Intl.DateTimeFormat("en-GB", { timeZone: value });
        }
        catch (error) {
            result = false;
        }
        return result;
    }
    TimeZone.is = is;
})(TimeZone || (TimeZone = {}));
//# sourceMappingURL=TimeZone.js.map